import { createRoutesWithSaveInProgress } from 'platform/forms/save-in-progress/helpers';
import formConfig from './config/form';
import App from './containers/App';
import ConversationPage from './containers/ConversationPage';
import ResponseSentPage from './containers/ResponseSentPage';
import InboxPage from './containers/InboxPage';

const routes = [
  {
    path: '/inbox/:id',
    component: ConversationPage,
  },
  {
    path: '/response-sent',
    component: ResponseSentPage,
  },
  {
    path: '/inbox',
    component: InboxPage,
  },
  {
    path: '/',
    component: App,
    indexRoute: {
      onEnter: (nextState, replace) =>
        replace(`/introduction${nextState.location.search}`),
    },
    childRoutes: createRoutesWithSaveInProgress(formConfig),
  },
];

export default routes;
